import React from 'react';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
//import CxHidden from '../../cx/CxHidden';
import CxDate from '../../cx/CxDate';
import CxInput from '../../cx/CxInput';
import CxSearcher from '../../cx/CxSearcher';
import CxTableMem from '../../cx/CxTableMem';
import * as FxLog from '../../fx/FxLog';
import * as FxNum from '../../fx/FxNum';
import * as FxTable from '../../fx/FxTable';
import * as FxFetch from '../../fx/FxFetch';
import * as FxStr from '../../fx/FxStr';
import '../../../styles/main.css';
import CxBackdrop from '../../cx/CxBackdrop';
import CxSnackbar from '../../cx/CxSnackbar';
import CxChooser from '../../cx/CxChooser';
import CxDialog from '../../cx/CxDialog';
import CxDlgAlert from '../../cx/CxDlgAlert';
import CxChip from '../../cx/CxChip';
import CxNumber from '../../cx/CxNumber';
import { StorePurLst, StorePurDoc, getStoreValue, getStoreValueBo } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import GxForm from '../../gx/GxForm';
import GxPrint from '../../gx/GxPrint';
import CxIconButton from '../../cx/CxIconButton';
import * as MxPurDocFormH1 from './MxPurDocFormH1';
import { useAccess } from '../../hx/useAccess';
import { FaCoins } from "react-icons/fa";
import { MdReceipt } from "react-icons/md";
import GxLongTaskWin from '../../gx/GxLongTaskWin';
import { useWindowSize } from '../../hx/useWindowSize';
import MxSupplierOTF from '../common/otf/MxSupplierOTF';


const MxPurDocForm = (props) => {
  const [{ trans }] = useTranslation();
  const size = useWindowSize();
  const [{ isFullAccess }] = useAccess(trans('field.purchases'));
  const [{ navTo, navBack }] = useNav();

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  // eslint-disable-next-line no-unused-vars
  const [storePurLst, setStorePurLst] = useSessionStorage('StorePurLst', StorePurLst);
  const [storePurDoc, setStorePurDoc] = useSessionStorage('StorePurDoc', StorePurDoc);

  const r_form = React.useRef(null);
  let r_print = React.useRef(null);
  let r_task = React.useRef(null);
  const r_dlg_new_supplier = React.useRef(null);

  const r_snack_op_successful = React.useRef(null);
  const r_snack_op_failed = React.useRef(null);
  const r_snack_delete = React.useRef(null);
  const r_dlg_alert = React.useRef(null);

  const [docTypeName, ] = React.useState(FxStr.choose(storePurDoc.docType, 'o|i|r', trans('field.order'), trans('field.invoice'), trans('field.receipt')));

  const [backdrop, setBackdrop] = React.useState(false);

  const [dlgIssue, setDlgIssue] = React.useState(false);
  const [dlgDelete, setDlgDelete] = React.useState(false);
  const [dlgExit, setDlgExit] = React.useState(false);

  const rf_chip_rec = React.useRef(null);
  const rf_chip_balance = React.useRef(null);

  const rf_dtPurXXX = React.useRef(null);
  const rf_txPurXXX = React.useRef(null);

  const rf_txSupplier = React.useRef(null);
  const rf_txBranch = React.useRef(null);
  const rf_txEmployee = React.useRef(null);
  const rf_txContact = React.useRef(null);
  const rf_txReference = React.useRef(null);
  const rf_nuTotalWtaxPerc = React.useRef(null);

  const rf_issue_dtPurXXX = React.useRef(null);
  const rf_issue_txPurXXX = React.useRef(null);

  const rf_table_mem_items = React.useRef(null);
  const rf_table_mem_payms = React.useRef(null);

  const rf_txNotes = React.useRef(null);

  const r_snack_error = React.useRef(null);


  React.useEffect(() => {
    try {
      FxLog.infox('MxPurDocForm.useEffect', '...storePurDoc.arItems:', storePurDoc.arItems);
      FxLog.infox('MxPurDocForm.useEffect', '...storePurDoc.arPayms:', storePurDoc.arPayms);
      
      formLoadCustom();
      
      // 2025-01-29 - daq: solución a problema que sucedía en clientes, que al volver de la impresión, se veían los ps duplicados.
      setBalance();
      if (storePurDoc.arItems) {
        // refresca el listado de items.
        rf_table_mem_items.current.setTheList(storePurDoc.arItems);
        rf_table_mem_items.current.refresh();
      }
      if (storePurDoc.arPayms && rf_table_mem_payms.current) {
        // refresca el listado de pagos.
        rf_table_mem_payms.current.setTheList(storePurDoc.arPayms);
        rf_table_mem_payms.current.refresh();
      }

    } catch (error) {
      FxLog.errorx('MxPurDocForm.setup', error);
    }
    // eslint-disable-next-line
  }, []);

  const sendStoreToForm = () => {
    try {
      if (rf_dtPurXXX.current) rf_dtPurXXX.current.setVal(storePurDoc.dtPurXXX);
      if (rf_txPurXXX.current) rf_txPurXXX.current.setVal(storePurDoc.txPurXXX);

      if (rf_txSupplier.current) rf_txSupplier.current.setKey(storePurDoc.inSupplier);
      if (rf_txSupplier.current) rf_txSupplier.current.setVal(storePurDoc.txSupplier);
      if (rf_txBranch.current) rf_txBranch.current.setKey(storePurDoc.inBranch);
      if (rf_txBranch.current) rf_txBranch.current.setVal(storePurDoc.txBranch);
      if (rf_txEmployee.current) rf_txEmployee.current.setKey(storePurDoc.inEmployee);
      if (rf_txEmployee.current) rf_txEmployee.current.setVal(storePurDoc.txEmployee);
      if (rf_txContact.current) rf_txContact.current.setVal(storePurDoc.txContact);
      if (rf_txReference.current) rf_txReference.current.setVal(storePurDoc.txReference);
      if (rf_nuTotalWtaxPerc.current) rf_nuTotalWtaxPerc.current.setVal(storePurDoc.nuTotalWtaxPerc||'0');

      if (rf_txNotes.current) rf_txNotes.current.setVal(storePurDoc.txNotes);

    } catch (error) {
      FxLog.errorx('MxPurDocForm.sendStoreToForm', error)
    }
  }

  const sendFormToStore = () => {
    try {
      if (rf_dtPurXXX.current) storePurDoc.dtPurXXX = rf_dtPurXXX.current.getVal();
      if (rf_txPurXXX.current) storePurDoc.txPurXXX = rf_txPurXXX.current.getVal();

      if (rf_txSupplier.current) storePurDoc.inSupplier = rf_txSupplier.current.getKey();
      if (rf_txSupplier.current) storePurDoc.txSupplier = rf_txSupplier.current.getVal();
      if (rf_txBranch.current) storePurDoc.inBranch = rf_txBranch.current.getKey();
      if (rf_txBranch.current) storePurDoc.txBranch = rf_txBranch.current.getVal();
      if (rf_txEmployee.current) storePurDoc.inEmployee = rf_txEmployee.current.getKey();
      if (rf_txEmployee.current) storePurDoc.txEmployee = rf_txEmployee.current.getVal();
      if (rf_txContact.current) storePurDoc.txContact = rf_txContact.current.getVal();
      if (rf_txReference.current) storePurDoc.txReference = rf_txReference.current.getVal();
      if (rf_nuTotalWtaxPerc.current) storePurDoc.nuTotalWtaxPerc = rf_nuTotalWtaxPerc.current.getVal();

      if (rf_txNotes.current) storePurDoc.txNotes = rf_txNotes.current.getVal();

      if (storePurDoc.boDataChanged === '0') {
        storePurDoc.boDataChanged = (r_form.current.wasChanged() ? '1' : '0');
      }

      setStorePurDoc(storePurDoc);

    } catch (error) {
      FxLog.errorx('MxPurDocForm.sendFormToStore', error)
    }
  }

  const formLoadCustom = () => {
    try {
      sendStoreToForm();

      if (!storePurDoc.inPurXXX) { //nuevo registro
        if (storePurDoc.boFirstRender) {
          if (rf_dtPurXXX.current) rf_dtPurXXX.current.setValToday();
          rf_txBranch.current.setKey(getStoreValue('StoreSession', 'inBranch'));
          rf_txBranch.current.setVal(getStoreValue('StoreSession', 'txBranch'));
          if (getStoreValueBo('StoreSession', 'boAutoSelEmployee')) {
            rf_txEmployee.current.setKey(getStoreValue('StoreSession', 'inEmployee'));
            rf_txEmployee.current.setVal(getStoreValue('StoreSession', 'txEmployee'));
          }
          storePurDoc.boFirstRender = false;
          setStorePurDoc(storePurDoc);

          // Forzar guardado de defaults para evitar pérdida al cambiar de pestaña
          setTimeout(() => {
            sendFormToStore();
          }, 250);
        }
      } else { // registro existente
      }

      setBalance();

    } catch (error) {
      FxLog.errorx('MxPurDocForm.formLoadCustom', error)
    }
  }

  const formSaveCustom = () => {
    try {
      if (r_form.current.hasIncompleteRequired()) {
        return;
      }
      sendFormToStore();
      
      FxLog.infox('MxPurDocForm.formSaveCustom', '...');
      r_task.current.doProcessStart();
      Promise.all([FxFetch.doJsonF(`pur/doc/cu/long_task`, null, storePurDoc)]).then((resultSave) => {
        setStorePurDoc(storePurDoc); // Esto actualiza la prop 'list' de CxTableMem
        rf_table_mem_items.current.redisplay();
        rf_table_mem_payms.current?.redisplay();
      });

    } catch (error) {
      FxLog.errorx('MxPurDocForm.formSaveCustom', error)
    }
  }

  const onTaskSaveProgress = (txProgressText, txTaskMessage, nuTaskPercentage) => {
    FxLog.infox('MxPurDocForm.onTaskSaveProgress', '...nuTaskPercentage:', nuTaskPercentage);
    r_task.current.getDlgAlert().setText(trans('msg.saving'));
    r_task.current.getDlgAlert().setProgressBarPerc(nuTaskPercentage);
    r_task.current.getDlgAlert().setTextColor('var(--ibs_color_blue)');
  }
  const onTaskSaveEnd = (txResultJson, txResultError) => {
    FxLog.infox('MxPurDocForm.onTaskSaveEnd', '...txResultJson:' + txResultJson);
    FxLog.infox('MxPurDocForm.onTaskSaveEnd', '...txResultError:' + txResultError);
    // limpieza y recarga
    if (txResultError) {
      r_task.current.getDlgAlert().setText(trans('msg.error') + ": " + txResultError);
      r_task.current.getDlgAlert().setTextColor('var(--ibs_color_red)');
      r_task.current.getDlgAlert().setAutoClose(true);
    return;
    }
    if (txResultJson) {
      let theJson = JSON.parse(txResultJson);
      FxLog.infox('MxPurDocForm.onTaskSaveEnd', '...inPurXXX:' + theJson['inPurXXX']);
      FxLog.infox('MxPurDocForm.onTaskSaveEnd', '...txPurXXX:' + theJson['txPurXXX']);
      r_form.current.resetChanged();
      storePurDoc.boDataChanged = '0';
      storePurDoc.inPurXXX = theJson['inPurXXX'];
      storePurDoc.arItems = [];
      storePurDoc.arPayms = [];
      Promise.all([MxPurDocFormH1.load(storePurLst, storePurDoc)]).then((result) => {
        setStorePurDoc(storePurDoc);
        rf_txPurXXX.current.setVal(theJson['txPurXXX']);
        r_task.current.getDlgAlert().setText(trans('msg.saved'));
        r_task.current.getDlgAlert().setTextColor('var(--ibs_color_green)');
        r_task.current.getDlgAlert().setAutoClose(true);
        forceUIUpdate();
      });
    }
  }

  const formDeleteCustom = () => {
    setDlgDelete(true);
  }

  const doDelete = () => {
    //-----------------------------------------------------------------------
    setBackdrop(true);

    let url = `pur/doc/${storePurDoc.docType}/d`;
    Promise.all([FxFetch.doJsonF(url, null, storePurDoc)]).then((result) => {
      FxLog.infox("MxPurDocForm.doDelete", "deleting record...", result);
      if (result[0]) {
        FxLog.infox("MxPurDocForm.doDelete", "Record was DELETED...responseData:", result[0]);
      } else {
        FxLog.infox("MxPurDocForm.doDelete", "Record was DEACTIVATED...responseData:", result[0]);
      }
      r_snack_delete.current.setOpen(true);
    });
    //-----------------------------------------------------------------------
  }

  const setBalance = () => {
    try {
      let nuTotalDiscount = 0;
      let nuTotalSurcharge = 0;
      let nuTotalTaxable = 0;
      let nuTotalTax = 0;
      let nuTotalAmount = 0;
      let nuTotalWtax = 0;
      let nuTotalFinal = 0;
      let nuTotalPayment = 0;

      if (storePurDoc.arItems) {
        storePurDoc.arItems.forEach(function (item, index) {
          nuTotalDiscount = nuTotalDiscount + parseFloat(item.nuDiscount);
          nuTotalSurcharge = nuTotalSurcharge + parseFloat(item.nuSurcharge);
          nuTotalTaxable = nuTotalTaxable + parseFloat(item.nuTaxable);
          nuTotalTax = nuTotalTax + parseFloat(item.nuTax);
          nuTotalAmount = nuTotalAmount + parseFloat(item.nuAmount);
          nuTotalFinal = nuTotalFinal + parseFloat(item.nuAmount);
        })
        storePurDoc.nuTotalWtaxPerc = rf_nuTotalWtaxPerc.current.getFloatVal();
        if (storePurDoc.nuTotalWtaxPerc !== 0) {
          nuTotalWtax = nuTotalTaxable * storePurDoc.nuTotalWtaxPerc / 100;
          nuTotalFinal = nuTotalAmount - nuTotalWtax;
        }
      }
      if (storePurDoc.arPayms) {
        storePurDoc.arPayms.forEach(function (paym, index) {
          nuTotalPayment = nuTotalPayment + parseFloat(paym.nuAmount);
        })
      }

      storePurDoc.nuTotalDiscount = nuTotalDiscount.toString();
      storePurDoc.nuTotalTaxable = nuTotalTaxable.toString();
      storePurDoc.nuTotalTax = nuTotalTax.toString();
      storePurDoc.nuTotalAmount = nuTotalAmount.toString();
      storePurDoc.nuTotalWtax = nuTotalWtax.toString();
      
      // 2023-01-12 - daq: tratamos los valores que se utilizan para el balance
      if (storePurDoc.docType === 'r') {
        nuTotalSurcharge = storePurDoc.nuTotalSurcharge;
        //nuTotalAmount = storePurDoc.nuTotalAmount;
        FxLog.infox('MxPurDocForm.setBalance', '...storePurDoc:', storePurDoc);
        nuTotalFinal = storePurDoc.nuTotalFinal - FxNum.to2r(nuTotalWtax);
        nuTotalPayment = storePurDoc.nuTotalPayment;
      } else {
        storePurDoc.nuTotalSurcharge = FxNum.to2r(nuTotalSurcharge).toString();
        //storePurDoc.nuTotalAmount = FxNum.to2r(nuTotalAmount).toString();
        storePurDoc.nuTotalFinal = FxNum.to2r(nuTotalFinal).toString();
        storePurDoc.nuTotalPayment = FxNum.to2r(nuTotalPayment).toString();
      }

      let balance = FxNum.to2r(nuTotalPayment) - (FxNum.to2r(nuTotalFinal) + FxNum.to2r(nuTotalSurcharge));
      storePurDoc.balance = balance;

      
      setStorePurDoc(storePurDoc);
      
      let total_label;
      if (storePurDoc.docType === 'o') {
        if (nuTotalSurcharge===0) {
          total_label = `${trans('field.total')}: ${FxTable.cellTo2r00(nuTotalAmount)}`;
          if (storePurDoc.docType !== 'r') rf_table_mem_items.current.setStatusbarText(null);
        } else {
          total_label = `${trans('field.total')}: ${FxTable.cellTo2r00(nuTotalAmount)} + ${trans('field.surcharge')}: ${FxTable.cellTo2r00(nuTotalSurcharge)} = ${FxTable.cellTo2r00(Math.abs(balance))}`;
          if (storePurDoc.docType !== 'r') rf_table_mem_items.current.setStatusbarText(`${trans('field.surcharge')}: ${FxTable.cellTo2r00(nuTotalSurcharge)}`);
        }
        rf_chip_balance.current.setLabel(`${trans('field.total')}: ${FxTable.cellTo2r00(Math.abs(balance))}`);
      } else {
        if (nuTotalSurcharge===0) {
          total_label = `${trans('field.total')}: ${FxTable.cellTo2r00(nuTotalAmount)} - ${trans('field.payment')}: ${FxTable.cellTo2r00(nuTotalPayment)} = ${FxTable.cellTo2r00(Math.abs(balance))}`;
          if (storePurDoc.docType !== 'r') rf_table_mem_items.current.setStatusbarText(null);
        } else {
          total_label = `${trans('field.total')}: ${FxTable.cellTo2r00(nuTotalAmount)} + ${trans('field.surcharge')}: ${FxTable.cellTo2r00(nuTotalSurcharge)} - ${trans('field.payment')}: ${FxTable.cellTo2r00(nuTotalPayment)} = ${FxTable.cellTo2r00(Math.abs(balance))}`;
          if (storePurDoc.docType !== 'r') rf_table_mem_items.current.setStatusbarText(`${trans('field.surcharge')}: ${FxTable.cellTo2r00(nuTotalSurcharge)}`);
        }
        rf_chip_balance.current.setWarn(balance < 0);
        rf_chip_balance.current.setLabel(`${trans('field.balance')}: ${FxTable.cellTo2r00(balance)}`);
      }
      rf_chip_balance.current.setTooltip(total_label);

    } catch (error) {
      FxLog.errorx('MxPurDocForm.setBalance', error)
    }
  }

  const openFormItem = async (op, row) => {
    // actualiza el store
    sendFormToStore();

    if (row === null) {
      storePurLst.table_item_idx = null;
    } else {
      storePurLst.table_item_idx = row.original["idx"];
    }
    setStorePurLst(storePurLst);
    setStorePurDoc(storePurDoc);

    navTo("pur-doc-form-item");
  }

  const openFormPaym = async (op, row) => {
    // actualiza el store
    sendFormToStore();

    if (row === null) {
      storePurLst.table_paym_idx = null;
    } else {
      storePurLst.table_paym_idx = row.original["idx"];
    }
    setStorePurLst(storePurLst);
    setStorePurDoc(storePurDoc);

    navTo("pur-doc-form-paym");
  }

  const supplierCleared = () => {
    storePurDoc.arRates = '';
    setStorePurDoc(storePurDoc);
  }

  const supplierChanged = (row) => {
    if (row !== null) {
      // inyecta filtros en el selector paciente
      //let inSupplier = row.original.inSupplier;
    }
  }

  const doPrintX = async (option) => {
    let inSupplier = storePurDoc.inSupplier;
    let filter = {};
    filter['reportFormat'] = `PDF`;
    filter['inSupplier'] = `${storePurDoc.inSupplier}`;
    filter['inPurXXX'] = `${storePurDoc.inPurXXX}`;
    filter['docType'] = `${storePurDoc.docType}`;
    filter['docSize'] = 'A4';
    let record = {};
    r_print.current.setScale(1.5);
    r_print.current.setUrl('purDoc/report');
    r_print.current.setPreview(true);
    //----------------
    Promise.all([
      r_print.current.setFilter(filter),
      r_print.current.setRecord(record),
      r_print.current.setInSupplier(inSupplier),
    ]).then((result) => {
      r_print.current.doPrint();
    });
  }

  const issueDoc = () => {
    try {
      if (rf_issue_dtPurXXX.current.isEmpty()) {
        r_snack_error.current.setVal(trans('field.required') + ": " + rf_issue_dtPurXXX.current.getLabel());
        r_snack_error.current.setOpen(true);
        return;
      }
      if (rf_issue_txPurXXX.current.isEmpty()) {
        r_snack_error.current.setVal(trans('field.required') + ": " + rf_issue_txPurXXX.current.getLabel());
        r_snack_error.current.setOpen(true);
        return;
      }
      if (storePurDoc.docType === 'i' && !storePurDoc.inPurReceipt) {
        let record = {};
        record['inPurInvoice'] = storePurDoc.inPurXXX;
        record['dtPurReceipt'] = rf_issue_dtPurXXX.current.getVal();
        record['txPurReceipt'] = rf_issue_txPurXXX.current.getVal();
        Promise.all([FxFetch.doJsonX(`pur/doc/issue_receipt_from_invoice`, record)]).then((result) => {
          storePurDoc.inPurReceipt = result[0].theValue;
          setStorePurDoc(storePurDoc);
          forceUIUpdate();
        });
      }
      if (storePurDoc.docType === 'o') {
        let record = {};
        record['inPurOrder'] = storePurDoc.inPurXXX;
        record['dtPurInvoice'] = rf_issue_dtPurXXX.current.getVal();
        record['txPurInvoice'] = rf_issue_txPurXXX.current.getVal();
        Promise.all([FxFetch.doJsonX(`pur/doc/issue_invoice_from_order`, record)]).then((result) => {
        });
      }
      setDlgIssue(false);
      r_snack_op_successful.current.setOpen(true);

    } catch (error) {
      FxLog.errorx("MxPurDocForm.issueDoc", error);
    }
  }

  const doStockUpdate = () => {
    try {
      if (storePurDoc.docType === 'i' && !storePurDoc.inPurReceipt) {
        let record = {};
        record['inPurInvoice'] = storePurDoc.inPurXXX;
        if (storePurDoc.nuStatus === '0') {
          storePurDoc.nuStatus = '1';
        } else {
          storePurDoc.nuStatus = '0';
        }
        record['nuStatus'] = storePurDoc.nuStatus;
        Promise.all([setStorePurDoc(storePurDoc)]).then((result) => {
          forceUIUpdate();
        });
        Promise.all([FxFetch.doJsonX(`pur/doc/stock_update`, record)]).then((result) => {
        });
      }
      r_snack_op_successful.current.setOpen(true);

    } catch (error) {
      FxLog.errorx("MxPurDocForm.doStockUpdate", error);
    }
  }

  const logStatus = () => {
    // eslint-disable-next-line no-unused-vars
    let status = {
      "storePurDoc.inPurXXX": storePurDoc.inPurXXX,
      "storePurDoc.nuStatus": storePurDoc.nuStatus,
      "storePurDoc.inPurReceipt": storePurDoc.inPurReceipt,
    }
  }

  const canGoBack = () => {
    if (storePurDoc.boDataChanged === '0') {
      storePurDoc.boDataChanged = (r_form.current.wasChanged() ? '1' : '0');
    }
    if (storePurDoc.boDataChanged === '0') {
      FxLog.infox("MxPurDocForm.canGoBack", "data was NOT changed!...");
      return true;
    } else {
      FxLog.infox("MxPurDocForm.canGoBack", "data was changed!...");
      setDlgExit(true);
      return false;
    }
  }


  /* no deja modificar o eliminar si es factura, o un albarán con factura, o está en el stock */
  const isDisabled = () => { return Boolean(storePurDoc.docType !== 'r' && ((storePurDoc.docType === 'i' && storePurDoc.inPurReceipt) || Boolean(storePurDoc.nuStatus==='0')) ? true : false) };

  const getTableItemColumns = () => {
    let cols = [];
    cols.push({ id: "id1", Header: "ID", accessor: "idx", show: false });
    cols.push({ id: "id2", Header: "ID", accessor: `${storePurLst.table_item_idField}`, show: false });
    if (size.isLarge) { // PANTALLA GRANDE
      cols.push({ id: "ps", Header: trans('field.ps'), accessor: "txPs", width: '24%' });
      cols.push({ id: "cd", Header: trans('field.code'), accessor: "txPsCode", width: '12%' });
      cols.push({ id: "lt", Header: trans('field.lot'), accessor: "txLotCode", width: '12%' });
      cols.push({ id: "qy", Header: trans('field.quantity_s'), accessor: row => FxTable.cellTo2r00(row["nuQuantity"]), width: '7%', align: 'right' });
      cols.push({ id: "pr", Header: trans('field.price'), accessor: row => FxTable.cellTo2r00(row["nuPrice"]), width: '9%', align: 'right' });
      cols.push({ id: "dp", Header: trans('field.discount_perc'), accessor: row => FxTable.cellTo2r00(row["nuDiscountPerc"]), width: '9%', align: 'right' });
      cols.push({ id: "tp", Header: trans('field.tax_perc'), accessor: row => FxTable.cellTo2r00(row["nuTaxPerc"]), width: '9%', align: 'right' });
      cols.push({ id: "sp", Header: trans('field.surcharge_perc'), accessor: row => FxTable.cellTo2r00(row["nuSurchargePerc"]), width: '9%', align: 'right' });
      cols.push({ id: "tot", Header: trans('field.total'), accessor: row => FxTable.cellTo2r00(row["nuAmount"]), width: '9%', align: 'right' });
      
    } else { // PANTALLA PEQUEÑA
      cols.push({ id: "ps", Header: trans('field.ps'), accessor: "txPs", width: '45%' });
      //cols.push({ id: "cd", Header: trans('field.code'), accessor: "txPsCode", width: '20%' });
      cols.push({ id: "qy", Header: trans('field.quantity'), accessor: row => FxTable.cellTo2r00(row["nuQuantity"]), width: '15%', align: 'right' });
      cols.push({ id: "tot", Header: trans('field.total'), accessor: row => FxTable.cellTo2r00(row["nuAmount"]), width: '20%', align: 'right' });
    }

    //cols.push({ id: 'P', Header: "_shopify", accessor: row => Boolean(row["boShopifyPs"] === '1'), show: false });

    return cols;
  }

  const getTablePaymColumns = () => {
    let cols = [];
    cols.push({ id: "id1", Header: "ID", accessor: "idx", show: false });
    cols.push({ id: "id2", Header: "ID", accessor: "inPurPayment", show: false });
    if (size.isLarge) { // PANTALLA GRANDE
      cols.push({ id: "dat", Header: trans('field.date'), accessor: row => FxTable.cellToLocalDate(row["dtPurPayment"]), width: '18%' });
      cols.push({ id: "typ", Header: trans('field.type'), accessor: "txTypePayment", width: '70%' });
      cols.push({ id: "tot", Header: trans('field.total'), accessor: row => FxTable.cellTo2r00(row["nuAmount"]), width: '12%', align: 'right' });
      
    } else { // PANTALLA PEQUEÑA
      cols.push({ id: "dat", Header: trans('field.date'), accessor: row => FxTable.cellToLocalDate(row["dtPurPayment"]), width: '30%' });
      cols.push({ id: "typ", Header: trans('field.type'), accessor: "txTypePayment", width: '50%' });
      cols.push({ id: "tot", Header: trans('field.total'), accessor: row => FxTable.cellTo2r00(row["nuAmount"]), width: '20%', align: 'right' });
    }

    return cols;
  }

  return (
    <div>
      {logStatus()}
      <GxForm
        xref={r_form}
        moduleName={`${trans('field.purchases')}: ${docTypeName}`}
        canGoBack={canGoBack}
        toolbarBackground={storePurLst.listTypeBackground}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>

            {/* botón de impresión */}
            {(storePurDoc.docType === 'o' || storePurDoc.docType === 'i' || storePurDoc.docType === 'r')
              && storePurDoc.inPurXXX
              && <CxIconButton type="print" classType="ibs_iconbutton_toolbar" onClick={() => doPrintX()} tooltip={trans('field.print')} />}

            {/* botón de añadir a stock */}
            {(storePurDoc.docType === 'i') && storePurDoc.inPurXXX && !storePurDoc.inPurReceipt && !isDisabled() 
              && <CxIconButton type="add_to" classType="ibs_iconbutton_toolbar" 
                 onClick={() => doStockUpdate()} tooltip={trans('field.add_to_x','field.stock')} />}
            {/* botón de quitar de stock */}
            {(storePurDoc.docType === 'i') && storePurDoc.inPurXXX && !storePurDoc.inPurReceipt && isDisabled() 
              && <CxIconButton type="remove_from" classType="ibs_iconbutton_toolbar" 
                 onClick={() => doStockUpdate()} tooltip={trans('field.remove_from_x','field.stock')} />}

            {/* botón de generación de albarán o factura */}
            {(storePurDoc.docType === 'o')
              && storePurDoc.inPurXXX && isFullAccess()
              && <CxIconButton type="issue" classType="ibs_iconbutton_toolbar" onClick={() => setDlgIssue(true)}
                tooltip={trans('field.issue_x','field.invoice')} />}
            {(storePurDoc.docType === 'i')
              && !storePurDoc.inPurReceipt && storePurDoc.inPurXXX && isFullAccess() && Boolean(storePurDoc.nuStatus==='0') 
              && <CxIconButton type="issue" classType="ibs_iconbutton_toolbar" onClick={() => setDlgIssue(true)}
                tooltip={trans('field.issue_x','field.receipt')} />}

            {/* botón eliminar. Sólo eliminar lo que no es factura ni relacionado a factura. */}
            {storePurDoc.inPurXXX && !isDisabled() && isFullAccess() 
              && <CxIconButton type="delete" classType="ibs_iconbutton_toolbar" onClick={() => formDeleteCustom()} tooltip={trans('field.delete')} />}

            {/* botón guardar. Incluso la factura puede guardar cambios para poder cambiar las notas. */}
            {isFullAccess() 
              && <CxIconButton type="save" classType="ibs_iconbutton_toolbar" onClick={() => formSaveCustom()} tooltip={trans('field.save')} />}

          </div>
        }
      >

        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'flex-end', gap: '5px' }}>
          {storePurDoc.docType === 'i' && storePurDoc.inPurReceipt && <CxChip xref={rf_chip_rec} icon={<MdReceipt size={20} color={"var(--ibs_color_toggle_green)"} />} label={trans('field.receipted')} />}
          <CxChip xref={rf_chip_balance} icon={<FaCoins size={18} color={"var(--ibs_color_cy_yellow)"} />} />
        </div>

        {/* DATOS DE DOCUMENTO */}
        {/* ----------------------------------------------------------------------------------------------------------------------------------- */}
        <CxDate xref={rf_dtPurXXX} label={trans('field.date')} required disabled={isDisabled()} />
        <CxInput xref={rf_txPurXXX} label={trans('field.doc')}
          maxLength="16"
          required
          disabled={isDisabled()}
        />

        {/* DATOS DE PROVEEDOR */}
        {/* ----------------------------------------------------------------------------------------------------------------------------------- */}
        <CxSearcher xref={rf_txSupplier}
          label={trans('field.supplier')}
          onClear={supplierCleared}
          onSelection={supplierChanged}
          url="suppliers"
          col_id="inSupplier"
          col_tx="txSupplier"
          refColors={ [ 'table_cell_color_red|' + trans('field.debtor') ] }
          tooltip={`${trans('field.supplier')}`}
          columns={[
            { id: "0", Header: "ID", accessor: "inSupplier", show: false },
            { id: "1", Header: trans('field.supplier'), accessor: row => rf_txSupplier.current.getTable().highlightText(row["txSupplier"]), width: '100%' },
            { id: "R", Header: "balance", accessor: row => Boolean((row["theBalance"]) < 0 ? true : false), show: false },
          ]}
          onButtonAddOTF={() => {
            rf_txSupplier.current.setDlg(false);
            r_dlg_new_supplier.current.setDlg(true);
          }}
          disabled={isDisabled()}
          required
        />

        <CxChooser xref={rf_txBranch}
          label={trans('field.branch')}
          id="n_branch"
          table="n_branch"
          col_id="inBranch"
          col_tx="txBranch"
          extra_filter_1={"boActive='1'"}
          disabled={isDisabled()}
          required
        />
        <CxSearcher xref={rf_txEmployee} label={trans('field.employee')}
          url="employees" col_id="inEmployee" col_tx="txEmployee"
          tooltip={`${trans('field.employee')}`}
          columns={[
            { id: "0", Header: "ID", accessor: "inEmployee", show: false },
            { id: "1", Header: trans('field.employee'), accessor: row => rf_txEmployee.current.getTable().highlightText(row["txEmployee"]), width: '100%' },
          ]}
          disabled={isDisabled()}
        />

        <CxInput xref={rf_txContact} label={trans('field.contact')} maxLength={100} disabled={isDisabled()} />
        <CxInput xref={rf_txReference} label={trans('field.reference')} maxLength={50} disabled={isDisabled()} />

        {(storePurDoc.docType === 'i' || storePurDoc.docType === 'o') && 
          <CxNumber xref={rf_nuTotalWtaxPerc} label={trans('field.wtax_perc')} decimals={2} decimalsfixed="true" defaultValue="0" onBlur={setBalance} autoselect="true" />
        }


        {/* PRODUCTOS Y SERVICIOS */}
        {/* ----------------------------------------------------------------------------------------------------------------------------------- */}
        {(storePurDoc.docType === 'i' || storePurDoc.docType === 'o') &&
          <CxTableMem
            id='doc_items'
            title={trans('field.pss')}
            xref={rf_table_mem_items}
            onOpenForm={openFormItem}
            hasButtonAdd={isFullAccess()}
            disabled={Boolean(isDisabled() || storePurDoc.inPurReceipt)}
            pageSize={5}
            list={storePurDoc.arItems || []}
            columns={getTableItemColumns()}
            //refColors={[ 'table_cell_color_pink|' + trans('field.shopify'), ]}   18-07-2026: quitamos porque cuando se añade nuevo item no queda rosa, y es complejo añadir esa lógica.
            label={trans('field.ps')}
            required
          />
        }

        {/* PAGOS */}
        {/* ----------------------------------------------------------------------------------------------------------------------------------- */}
        {storePurDoc.docType === 'i' &&
          <CxTableMem
            id='doc_payms'
            title={trans('field.payments')}
            xref={rf_table_mem_payms}
            onOpenForm={openFormPaym}
            hasButtonAdd={isFullAccess()}
            disabled={false}
            pageSize={5}
            list={storePurDoc.arPayms || []}
            columns={getTablePaymColumns()}
          />
        }

        {/* NOTAS */}
        {/* ----------------------------------------------------------------------------------------------------------------------------------- */}
        <CxInput xref={rf_txNotes} label={trans('field.notes')} minRows={2} disabled={isDisabled()} />

      </GxForm>

      <CxDlgAlert xref={r_dlg_alert} />

      <CxSnackbar xref={r_snack_op_successful} severity="success" value={trans('msg.operation_successful')} />
      <CxSnackbar xref={r_snack_op_failed} severity="error" value={trans('msg.operation_failed')} />
      <CxSnackbar xref={r_snack_delete} severity="success" value={trans('msg.deleted')} onClose={() => { navBack(); }} />

      <CxDialog
        title={trans('field.issue_x', storePurDoc.docType === 'o' ? trans('field.invoice') : trans('field.receipt'))}
        open={dlgIssue}
        onCancel={() => setDlgIssue(false)} 
        onOk={() => issueDoc()}
        height='300px'>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }} >
          <CxDate xref={rf_issue_dtPurXXX} label={trans('field.date')} width='var(--ibs_control_width_md)' today required />
          <CxInput xref={rf_issue_txPurXXX} label={trans('field.doc')} width='var(--ibs_control_width_md)' required />
        </div>
      </CxDialog>

      <CxDialog title={trans('msg.confirm_operation')} open={dlgExit} onCancel={() => setDlgExit(false)} onOk={() => navBack()} height='200px'>
        {trans('msg.ask_exit_without_saving')}
      </CxDialog>

      <CxDialog title={trans('msg.warning')} open={dlgDelete}
        onCancel={() => setDlgDelete(false)}
        onOk={() => { setDlgDelete(false); doDelete() }}
        height='200px'>
        {trans('msg.ask_delete')}
      </CxDialog>

      <MxSupplierOTF xref={r_dlg_new_supplier} onOk={(inSupplier, txSupplier) => {
        rf_txSupplier.current.setKey(inSupplier);
        rf_txSupplier.current.setVal(txSupplier);
      }} />

      <GxPrint xref={r_print}/>
      <CxBackdrop open={backdrop} />
      <CxSnackbar xref={r_snack_error} severity="error" />

      <GxLongTaskWin xref={r_task} txTaskName="tsk_pur_doc_save" onProgress={onTaskSaveProgress} onEnd={onTaskSaveEnd} />

    </div>
  );

}

export default MxPurDocForm;
